<div class="text-qr_color-gray text-16 py-1 font-semibold" v-html="subheadlineHtml">
  {{subheadline}}
</div>